import { render, staticRenderFns } from "./ShowVideoPopup.vue?vue&type=template&id=45c8b3b2&scoped=true&"
import script from "./ShowVideoPopup.vue?vue&type=script&lang=ts&"
export * from "./ShowVideoPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ShowVideoPopup.vue?vue&type=style&index=0&id=45c8b3b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8b3b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c8b3b2')) {
      api.createRecord('45c8b3b2', component.options)
    } else {
      api.reload('45c8b3b2', component.options)
    }
    module.hot.accept("./ShowVideoPopup.vue?vue&type=template&id=45c8b3b2&scoped=true&", function () {
      api.rerender('45c8b3b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ShowVideoPopup.vue"
export default component.exports